import { AccordionDetails, AccordionSummary, Box, Stack, Typography } from '@mui/material';
import { ExpandMore } from '@mui/icons-material';
import { formatCurrency } from 'utils';
import { Nullable } from 'global';
import { dealSummaryGetEquipmentTitle } from '../../../../lib';
import { DealBuilderEquipmentSource } from '../../../../types';
import { DealBuilderQuote } from '../../../../api';
import { FlatAccordion } from './FlatAccordion';
import { PriceField } from './PriceField';
import { QuoteCalcViewModel } from 'modules/quote/api/types';

interface Props {
  quote: Nullable<DealBuilderQuote>;
  priceCalc: Nullable<QuoteCalcViewModel>;
  equipmentData: Nullable<DealBuilderEquipmentSource[]>;
}

export const EquipmentItemsSection = ({ quote, priceCalc, equipmentData }: Props) => (
  <FlatAccordion defaultExpanded disableGutters>
    <AccordionSummary expandIcon={<ExpandMore />}>
      <Stack direction="row" justifyContent="space-between" flex={1} pr={1}>
        <Typography fontWeight={500}>Equipment</Typography>
        <Stack direction="row" alignItems="center" gap={0.5}>
          <Typography variant="subtitle2" color="text.secondary" component="span">
            Total Equipment:
          </Typography>
          <Typography fontWeight={500}>
            {formatCurrency(priceCalc?.netFinanceAmount?.hardCost /* quote?.equipmentSubtotal */ ?? 0, true)}
          </Typography>
        </Stack>
      </Stack>
    </AccordionSummary>
    <AccordionDetails>
      <Stack gap={1.5}>
        {(quote?.equipment ?? []).map(item => (
          <Box key={item.equipmentId} p={1.5} borderRadius={1} border={1} borderColor="grey.200" bgcolor="#f7f8fa">
            <Typography variant="body1">{dealSummaryGetEquipmentTitle(item, equipmentData)}</Typography>
            <Stack direction="row" justifyContent="space-between" gap={2} mt={0.5}>
              <PriceField label="Retail" value={item.price?.retailPrice} />
              <PriceField
                label="Discount"
                value={item.price?.discount ? -item.price.discount : 0}
                color="success.main"
              />
              <PriceField label="Subtotal" value={item.price?.netPrice} />
            </Stack>
          </Box>
        ))}
      </Stack>
    </AccordionDetails>
  </FlatAccordion>
);
